import { useLoginContext } from "../../../App";
import { getOrganizationImagePathWithApiKey, getOrganizationNameWithApiKey } from "../../../services/b2b-users-apiService"
import { useQuery } from "@tanstack/react-query";

const useGetOrganizationInfo = () => {
    const { loginData } = useLoginContext();

    const fetchOrganizationName = async () => {
        try {
            const response = await getOrganizationNameWithApiKey(loginData.loggedOrganizationUuid);
            return response;
        } catch (error) {
            console.error('Error fetching organization name: ' + error.message);
            return 'Error';
        }
    }

    const fetchOrganizationImage = async () => {
        try {
            const response = await getOrganizationImagePathWithApiKey(loginData.loggedOrganizationUuid);
            return response;
        } catch (error) {
            console.error('Error fetching organization image: ' + error.message);
            return 'Error';
        }
    }

    const { data: organizationName } = useQuery({
        queryKey: ['organizationName', loginData.loggedOrganizationUuid],
        queryFn: fetchOrganizationName,
        enabled: !!loginData?.loggedOrganizationUuid,
    });

    const { data: organizationImage } = useQuery({
        queryKey: ['organizationImage', loginData.loggedOrganizationUuid],
        queryFn: fetchOrganizationImage,
        enabled: !!loginData?.loggedOrganizationUuid,
    });

    return { organizationName, organizationImage };
}

export default useGetOrganizationInfo;